<template>
  <v-card elevation="0" class="mx-auto mt-4 mb-0">
    <v-card-text>
      <v-form>
        <v-container fluid>
          <v-row>
            <v-col cols="12" lg="3" sm="4">
              <v-text-field
                v-model.trim="$v.telegram.adm.$model"
                :error-messages="admError"
                name="adm"
                label="Código Administrador"
              />
            </v-col>
            <v-col
              cols="12"
              lg="3"
              sm="4"
              v-for="(value, idx) in telegram.watch"
              :key="idx"
            >
              <v-text-field
                v-model.trim="telegram.watch[idx]"
                :value="value"
                :name="`user_${idx}`"
                :label="`Código usuário ${idx + 1}`"
              />
            </v-col>
            <AlertTelegram/>
            <v-spacer />
            <v-col cols="12" col="4" class="align-content-end">
              <v-btn
                :disabled="$v.$invalid || disableSubmit ? true : false"
                color="verde"
                dark
                class="font-weight-light"
                right
                type="submit"
                @click.prevent="submit"
              >
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="ml-2"
                @click="$emit('cancel')"
                v-show="showBtnCancelScan"
                >Cancel</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import AlertTelegram from './AlertTelegram'
import { required, minLength } from "vuelidate/lib/validators";
import { existsProp, uuidv4 } from "../../services/utils";

export default {
  components:{AlertTelegram},
  name: "Notification",
  data: () => {
    return {
      telegram: {
        adm: "",
        watch: ["", "", "", "", "", ""]
      },
      maxWidthCard: "100%",
      disableBtn: false,
      showBtnCancelScan: false,
      event: null
    };
  },
  validations: {
    telegram: {
      adm: { required, minLength: minLength(4) }
    }
  },
  computed: {
    admError() {
      const errors = [];
      const input = this.$v.telegram.adm;
      if (!input.$dirty) {
        return errors;
      }
      !input.required && errors.push("Código do administrador é obrigatório");
      !input.minLength && errors.push("Código do administrador inválido");
      return errors;
    },
    disableSubmit: {
      set(value) {
        this.disableBtn = value;
      },
      get() {
        return this.disableBtn;
      }
    }
  },
  methods: {
    getDate() {
      let datetime = new Date();
      let split = datetime.toISOString().split("T");
      return split[0] + " " + split[1].split(".")[0];
    },
    uuid() {
      return uuidv4();
    },
    submit() {
      this.disableSubmit = true;
      let check = false;
      this.telegram.watch.forEach(value => {
        if (value.length > 0) {
          check = true;
        }
      });
      let length_watch = this.telegram.watch.length;
      if (length_watch < 6) {
        for (let i = 0; i <= 5; i++) {
          if (typeof this.telegram.watch[i] === "undefined") {
            this.telegram.watch.push("");
          }
        }
      }
      if (length_watch < 6 || check == false) {
        this.$store.dispatch(
          "setMsgError",
          "Verifique se foi preenchido ao menos um código de usuário para receber a notificação!"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        this.telegram.watch.splice(5);
        this.disableSubmit = false;
        return;
      }
      this.disableSubmit = false;
      let event_name = "operation-50";
      this.$store.dispatch("displayLoading", true);
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$store.getters.hostActive,
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: { operation: 50, data: { telegram: this.telegram } }
        },
        false
      );
      if (this.showBtnCancelScan == true) {
        this.$emit("next");
      }
      this.$root.$on(event_name, obj => {
        this.$store.dispatch("displayLoading", false);
        this.$store.dispatch("setInfoNotificacao", obj.result.telegram);
        if (this.showBtnCancelScan == false) {
          this.$store.dispatch("MsgSucces", "Operação realizada com sucesso");
          this.$store.dispatch("displayMsgSuccess", true);
          return 
        }
        this.$store.dispatch("setInfoNotificacao", obj.result.telegram);
      });
    },
    loadInformacoes(){
      // let item = this.$store.getters.infoNotificacao;
      let event_name = "operation-60-busca-por-telegram";
      this.$store.dispatch("displayLoading", true);
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$alertme.getHostIdUrl(this.$route),
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: { operation: 60 }
        },
        false
      );
      this.$root.$on(event_name, obj => {
        this.$store.dispatch("displayLoading", false);
        if(existsProp(obj.result,'telegram')) {
            this.$store.dispatch("setInfoNotificacao", obj.result.telegram);
            this.telegram.adm = obj.result.telegram.adm;
            let watch = [...obj.result.telegram.watch];
            if(watch.length<5) {
              for(let i=watch.length;i<=5;i++) {
                watch.push("")
              }
            }
            this.telegram.watch = watch
        }
      });
    }
  },
  props: ["maxWidth", "btnCancel"],
  created() {
    this.$root.clearHashTable()
    this.$root.abortFindMessageServer()
    this.maxWidthCard = !this.maxWidth ? "90%" : this.maxWidth;
    this.showBtnCancelScan = !this.btnCancel ? false : true;
    this.loadInformacoes()
    //
    this.$on('reloadNotification',()=>{
      this.loadInformacoes()
    })
  },
  destroyed() {
    this.$root.clearHashTable()
    this.$root.abortFindMessageServer()
  }
};
</script>